import { SmoothScrollOptions } from 'vue3-smooth-scroll'

const settings: SmoothScrollOptions = {
  duration: 800,
  offset: -100,
  scrollTo: 0,
}

export default settings
